import { SupabaseClient } from "@supabase/supabase-js";
import { supabase } from "../../config/supabaseClient";
import { updateRefClick } from "./ContentDatabase";
import { getClientIp } from "./getClientIp";

export enum TRACKING_EMBED_TYPES {
  PAGE = "page",
  EVENT = "event",
  ERROR = "error",
  SEARCH = "search",
}

/**
 * Pathname contract for embed_analytics RPCs (`route_name = /embed/{username}`).
 * Click writers historically used `/{username}`, so dashboard item clicks never matched.
 */
export function embedAnalyticsPathname(username: string): string {
  const slug = String(username || "")
    .trim()
    .toLowerCase()
    .replace(/^\/+|\/+$/g, "");
  return slug ? `/embed/${slug}` : "/embed";
}

export default async function trackEmbed(
  name: string,
  type: TRACKING_EMBED_TYPES,
  extras?: { pathname?: string; details?: any; title?: string; user_id?: any },
  client: SupabaseClient = supabase
) {
  // chack params, they should be in the right format
  if (
    typeof name !== "string" ||
    !Object.values(TRACKING_EMBED_TYPES).includes(type)
  ) {
    return;
  }

  let success = false;
  const trackingObject = {
    ip: "",
    type,
    name,
    pathname: extras?.pathname || "",
    details: extras?.details || "",
    title: extras?.title || "",
    user_id: extras?.user_id || "",
  };
  try {
    trackingObject.ip = await getClientIp();
    const { error } = await client.from("embed_analytics").insert([trackingObject]);

    if (!error) {
      success = true;
    }
  } catch (err) {
    trackingObject.ip = "";
    trackingObject.type = TRACKING_EMBED_TYPES.ERROR;
    trackingObject.name = "Tracking Error";
    const { error } = await client.from("embed_analytics").insert([trackingObject]);
    if (!error) {
      success = true;
    }
  } finally {
    if (!success) {
    }
  }
}



function embedPathFromWindow(): string {
  if (typeof window === "undefined") return "/embed";
  const path = String(window.location.pathname || "");
  const match = path.match(/\/embed\/([^/]+)/i);
  if (match?.[1]) return embedAnalyticsPathname(decodeURIComponent(match[1]));
  return path.startsWith("/embed") ? path : "/embed";
}

export function handleRedirect(postId: string, media_url: string, platform: string, name: any, user_id: string) {

  trackEmbed("Redirect to original post", TRACKING_EMBED_TYPES.EVENT, {
    pathname: embedPathFromWindow(),
    details: { post_id: postId, media_url: media_url, platform: platform, name },
    user_id: user_id,
    title: "Stay Up To Date",
  });
  updateRefClick(postId, user_id);
}



export const handleShop = (postId: any, mediaUrl: any, platform: any, name: any, user_id: any) => {

  trackEmbed("Redirect to shop link", TRACKING_EMBED_TYPES.EVENT, {
    pathname: embedPathFromWindow(),
    details: { post_id: postId, media_url: mediaUrl, platform: platform, name },
    user_id: user_id,
    title: "Stay Up To Date",
  });
};


export const handleTagged = (postId: any, mediaUrl: any, platform: any, name: any, user_id: any) => {
  trackEmbed("Redirect to tagged link", TRACKING_EMBED_TYPES.EVENT, {
    pathname: embedPathFromWindow(),
    details: { post_id: postId, media_url: mediaUrl, platform: platform, name },
    user_id: user_id,
    title: "Stay Up To Date",
  });
};
